export const countrylist = {
  countries: [
    { code: "+93",    name: "Afghanistan", iso: "AF", flag: "🇦🇫" },
    { code: "+355",   name: "Albania", iso: "AL", flag: "🇦🇱" },
    { code: "+213",   name: "Algeria", iso: "DZ", flag: "🇩🇿" },
    { code: "+376",   name: "Andorra", iso: "AD", flag: "🇦🇩" },
    { code: "+244",   name: "Angola", iso: "AO", flag: "🇦🇴" },
    { code: "+1 264", name: "Anguilla", iso: "AI", flag: "🇦🇮" },
    { code: "+1 268", name: "Antigua and Barbuda", iso: "AG", flag: "🇦🇬" },
    { code: "+54",    name: "Argentina", iso: "AR", flag: "🇦🇷" },
    { code: "+374",   name: "Armenia", iso: "AM", flag: "🇦🇲" },
    { code: "+297",   name: "Aruba", iso: "AW", flag: "🇦🇼" },
    { code: "+61",    name: "Australia", iso: "AU", flag: "🇦🇺" },
    { code: "+43",    name: "Austria", iso: "AT", flag: "🇦🇹" },
    { code: "+994",   name: "Azerbaijan", iso: "AZ", flag: "🇦🇿" },
    { code: "+1 242", name: "Bahamas", iso: "BS", flag: "🇧🇸" },
    { code: "+973",   name: "Bahrain", iso: "BH", flag: "🇧🇭" },
    { code: "+880",   name: "Bangladesh", iso: "BD", flag: "🇧🇩" },
    { code: "+1 246", name: "Barbados", iso: "BB", flag: "🇧🇧" },
    { code: "+375",   name: "Belarus", iso: "BY", flag: "🇧🇾" },
    { code: "+32",    name: "Belgium", iso: "BE", flag: "🇧🇪" },
    { code: "+501",   name: "Belize", iso: "BZ", flag: "🇧🇿" },
    { code: "+229",   name: "Benin", iso: "BJ", flag: "🇧🇯" },
    { code: "+1 441", name: "Bermuda", iso: "BM", flag: "🇧🇲" },
    { code: "+975",   name: "Bhutan", iso: "BT", flag: "🇧🇹" },
    { code: "+591",   name: "Bolivia", iso: "BO", flag: "🇧🇴" },
    { code: "+387",   name: "Bosnia and Herzegovina", iso: "BA", flag: "🇧🇦" },
    { code: "+267",   name: "Botswana", iso: "BW", flag: "🇧🇼" },
    { code: "+55",    name: "Brazil", iso: "BR", flag: "🇧🇷" },
    { code: "+1 284", name: "British Virgin Islands", iso: "VG", flag: "🇻🇬" },
    { code: "+673",   name: "Brunei", iso: "BN", flag: "🇧🇳" },
    { code: "+359",   name: "Bulgaria", iso: "BG", flag: "🇧🇬" },
    { code: "+226",   name: "Burkina Faso", iso: "BF", flag: "🇧🇫" },
    { code: "+257",   name: "Burundi", iso: "BI", flag: "🇧🇮" },
    { code: "+855",   name: "Cambodia", iso: "KH", flag: "🇰🇭" },
    { code: "+237",   name: "Cameroon", iso: "CM", flag: "🇨🇲" },
    { code: "+1",     name: "Canada", iso: "CA", flag: "🇨🇦" },
    { code: "+238",   name: "Cape Verde", iso: "CV", flag: "🇨🇻" },
    { code: "+236",   name: "Central African Republic", iso: "CF", flag: "🇨🇫" },
    { code: "+235",   name: "Chad", iso: "TD", flag: "🇹🇩" },
    { code: "+56",    name: "Chile", iso: "CL", flag: "🇨🇱" },
    { code: "+86",    name: "China", iso: "CN", flag: "🇨🇳" },
    { code: "+57",    name: "Colombia", iso: "CO", flag: "🇨🇴" },
    { code: "+242",   name: "Congo", iso: "CG", flag: "🇨🇬" },
    { code: "+243",   name: "Congo, Dem. Rep.", iso: "CD", flag: "🇨🇩" },
    { code: "+506",   name: "Costa Rica", iso: "CR", flag: "🇨🇷" },
    { code: "+385",   name: "Croatia", iso: "HR", flag: "🇭🇷" },
    { code: "+53",    name: "Cuba", iso: "CU", flag: "🇨🇺" },
    { code: "+420",   name: "Czech Republic", iso: "CZ", flag: "🇨🇿" },
    { code: "+45",    name: "Denmark", iso: "DK", flag: "🇩🇰" },
    { code: "+253",   name: "Djibouti", iso: "DJ", flag: "🇩🇯" },
    { code: "+1 767", name: "Dominica", iso: "DM", flag: "🇩🇲" },
    { code: "+1 809", name: "Dominican Republic", iso: "DO", flag: "🇩🇴" },
    { code: "+670",   name: "East Timor", iso: "TL", flag: "🇹🇱" },
    { code: "+593",   name: "Ecuador", iso: "EC", flag: "🇪🇨" },
    { code: "+20",    name: "Egypt", iso: "EG", flag: "🇪🇬" },
    { code: "+503",   name: "El Salvador", iso: "SV", flag: "🇸🇻" },
    { code: "+240",   name: "Equatorial Guinea", iso: "GQ", flag: "🇬🇶" },
    { code: "+291",   name: "Eritrea", iso: "ER", flag: "🇪🇷" },
    { code: "+372",   name: "Estonia", iso: "EE", flag: "🇪🇪" },
    { code: "+251",   name: "Ethiopia", iso: "ET", flag: "🇪🇹" },
    { code: "+298",   name: "Faroe Islands", iso: "FO", flag: "🇫🇴" },
    { code: "+679",   name: "Fiji", iso: "FJ", flag: "🇫🇯" },
    { code: "+358",   name: "Finland", iso: "FI", flag: "🇫🇮" },
    { code: "+33",    name: "France", iso: "FR", flag: "🇫🇷" },
    { code: "+241",   name: "Gabon", iso: "GA", flag: "🇬🇦" },
    { code: "+995",   name: "Georgia", iso: "GE", flag: "🇬🇪" },
    { code: "+49",    name: "Germany", iso: "DE", flag: "🇩🇪" },
    { code: "+233",   name: "Ghana", iso: "GH", flag: "🇬🇭" },
    { code: "+30",    name: "Greece", iso: "GR", flag: "🇬🇷" },
    { code: "+502",   name: "Guatemala", iso: "GT", flag: "🇬🇹" },
    { code: "+1 671", name: "Guam", iso: "GU", flag: "🇬🇺" },
    { code: "+852",   name: "Hong Kong", iso: "HK", flag: "🇭🇰" },
    { code: "+36",    name: "Hungary", iso: "HU", flag: "🇭🇺" },
    { code: "+354",   name: "Iceland", iso: "IS", flag: "🇮🇸" },
    { code: "+91",    name: "India", iso: "IN", flag: "🇮🇳" },
    { code: "+62",    name: "Indonesia", iso: "ID", flag: "🇮🇩" },
    { code: "+98",    name: "Iran", iso: "IR", flag: "🇮🇷" },
    { code: "+964",   name: "Iraq", iso: "IQ", flag: "🇮🇶" },
    { code: "+353",   name: "Ireland", iso: "IE", flag: "🇮🇪" },
    { code: "+971",   name: "United Arab Emirates", iso: "AE", flag: "🇦🇪" },
    { code: "+44",    name: "United Kingdom", iso: "GB", flag: "🇬🇧" },
    { code: "+1",     name: "United States", iso: "US", flag: "🇺🇸" },
    
    // Added missing countries:
    
    { code: "+63",    name: "Philippines", iso: "PH", flag: "🇵🇭" },
    { code: "+81",    name: "Japan", iso: "JP", flag: "🇯🇵" },
    { code: "+82",    name: "South Korea", iso: "KR", flag: "🇰🇷" },
    { code: "+65",    name: "Singapore", iso: "SG", flag: "🇸🇬" },
    { code: "+52",    name: "Mexico", iso: "MX", flag: "🇲🇽" },
    { code: "+39",    name: "Italy", iso: "IT", flag: "🇮🇹" },
    { code: "+7",     name: "Russia", iso: "RU", flag: "🇷🇺" },

    { code: "+84",    name: "Vietnam", iso: "VN", flag: "🇻🇳" },
    { code: "+263",   name: "Zimbabwe", iso: "ZW", flag: "🇿🇼" },
  ],
};
